import styles from './Buttons.module.css';

const Button = (props) => {
  const { buttonText, handleFunction } = props

  return (
    <button className={styles.mainPageButtons} onClick={(e) => {handleFunction(e)}}>{buttonText}</button>
  )
}

export default Button;